<template>
    <div class="sidebar">
        <div class="sidebar-wrapper" :class="{'open':menuOpen}" >
		<div class="sidebar-heading" >
			<div class="background" v-if="loggedPharmacy.picture" :style="'background-image:url('+API_URL+loggedPharmacy.picture.urlThumb+')'"></div>
			<div class="profile-data">
				<ProfileCard></ProfileCard>
			</div>
		</div>
		<div class="list-group list-group-flush" @click="toggleMenu">
			<router-link to="/profile" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="pe-7s-user"></i></div>
				<span>Mi Perfil</span>
			</router-link>
			
			<router-link to="/dispensations" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="icon-medicine"></i></div>
				<span>Historial Dispensaciones</span>
			</router-link>


			<!-- <router-link to="/valorations" class="list-group-item list-group-item-action ">
				<div class="icon"><i class="pe-7s-comment"></i></div>
				<span>Valoraciones</span>
			</router-link> -->
			
			
		
		
			<div class="list-group-item list-group-item-action installer-button" v-if="$installer.canInstall" @click="$installer.prompt">
				<div class="icon"><i class="fa fa-mobile"></i></div>
				<span>Instalar en dispositivo</span>
			</div>
			
		

			<router-link to="/logout" class="list-group-item list-group-item-action bottom ">
				<div class="icon"><i class="pe-7s-lock"></i></div>
				<span>Salir</span>
			</router-link>
		
		</div>
	</div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ProfileCard from '@/views/account/ProfileCard';

export default {
    name: 'Sidebar',
    components:{
        ProfileCard
	},
	props:['open'],
	data(){
		return{
			API_URL: process.env.VUE_APP_API_URL,
		}
	},
	computed: {
		...mapGetters(['loggedPharmacy','menuOpen'])
	},
	methods: {
        ...mapMutations(['toggleMenu'])
    },
	
}
</script>

<style scoped>

	.sidebar-wrapper {
		background-color:#fff;
		width: 280px;
		height: calc(100% - 62px);
		overflow: hidden;
		position: fixed;
		top: 62px;
		left: 0px;
		z-index: 1000;
		-webkit-transition: all .15s ease-in-out;
		-moz-transition: all .15s ease-in-out;
		-o-transition: all .15s ease-in-out;
		transition: all .15s ease-in-out;
	}
	

	.sidebar-wrapper .sidebar-heading {
		position: relative;
	}
	.sidebar-wrapper .sidebar-heading .profile-data{
		z-index: 10;
		display: grid;
	}
	.sidebar-wrapper .sidebar-heading .background{
		position: absolute;
		top: 0px;
		width: 100%;
		height: 100%;
		background-size: cover;
		filter: blur(8px);
		-webkit-filter: blur(8px);
		z-index: 0;
		opacity: 0.3;
	}

	.sidebar-wrapper .sidebar-heading .logo{
		display: none;
		
	}
	.sidebar-wrapper .sidebar-heading .logo-expanded{
		display: block;		
	}
	.sidebar-wrapper:hover .sidebar-heading .logo{
		display: block;
	}
	.sidebar-wrapper:hover .sidebar-heading .logo-expanded{
		display: none;		
	}
	.sidebar-wrapper .sidebar-heading h2 {
		font-size: 14px;
		text-align: center;
		color: #fff;
		padding: 18px;
	}

	.logo{
		max-width: 15rem;
		max-height: 60px;
	}

	.sidebar-wrapper .list-group {
		width: 280px;
		height: calc(100% - 200px);
	}
	.sidebar-wrapper .list-group .list-group-item{
		background-color: transparent;
		color: #2d323e;
		padding: 8px 0px;
        border: none;
        display: flex;
        align-content:center;
		align-items: center;
	}
	.sidebar-wrapper .list-group .list-group-item:hover{
		background-color: #f1f1f1;
		color: #000;
	}

	.sidebar-wrapper .list-group .list-group-item .icon{
		width: 64px;
		text-align: center;
        flex-grow: 0;
        flex-shrink: 0;
    }
    .sidebar-wrapper .list-group .list-group-item .icon i{
        font-size: 24px;
	}
	.sidebar-wrapper .list-group .list-group-item span{
		flex-grow: 1;
        font-size: 15px;
        line-height: 34px;
		-webkit-transition: all .15s ease-in-out;
		-moz-transition: all .15s ease-in-out;
		-o-transition: all .15s ease-in-out;
		transition: all .15s ease-in-out;
				
	}

	.sidebar-wrapper:hover .list-group .list-group-item span{
		opacity: 1;
    }
    

    @media (max-width: 991px) {
		
        .sidebar-wrapper {
            width: 64px;
            position: absolute;
        }
        .sidebar-wrapper:hover {
            width: 280px;
        }

        .sidebar-wrapper .sidebar-heading h2 {
            display: none;
        }
        .sidebar-wrapper:hover .sidebar-heading h2 {
            display: block;
        }
        .sidebar-wrapper .list-group .list-group-item span{
            opacity: 0;                 
        }
    }


	@media (max-width: 576px) {

		.sidebar-wrapper{
			width: 220px;
			left: -230px;
			-webkit-box-shadow: 0px 5px 5px 0px rgba(0,0,0,0.36);
			-moz-box-shadow: 0px 5px 5px 0px rgba(0,0,0,0.36);
			box-shadow: 0px 5px 5px 0px rgba(0,0,0,0.36);
			position: fixed;
			top: 62px;
			height: calc(100% - 62px);
		}
		.sidebar-wrapper.open {
			width: 220px;
			left: 0px;
		}
		.sidebar-wrapper .list-group .list-group-item span{
            opacity: 1;                 
        }
	}

.list-group-item.bottom{
    bottom: 0px;
    position: absolute;
}

.installer-button{
	cursor: pointer;
}


.investment-banner{
	background-image: url('~@/assets/img/about-us.png');
	background-size: cover;
	background-position: center center;
	padding: 16px 8px;
	color: #fff;
	font-size: 16px;
	text-align: center;
	display: block;
}




@media (max-width: 991px) {
	.investment-banner{
		display:none;
	}
}

</style>
